module.exports = __webpack_public_path__ + "static/rhashaak-f01e087e60017c897f974628e37e2070.jpg";